import * as React from 'react';
import cn from 'clsx';
import { UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IAdditionalServiceAboutButtonProps {
  className?: string;
  onClick: () => void;
}

export const AdditionalServiceAboutButton: React.FC<React.PropsWithChildren<IAdditionalServiceAboutButtonProps>> = ({
  className,
  onClick,
}) => {
  return (
    <button className={cn(styles['button'], className)} type="button" onClick={onClick}>
      <UIText1 fontWeight="bold" color="primary_100">
        Подробнее
      </UIText1>
    </button>
  );
};
